/* Nieuwe homepage: het typmachine-effect, de fotofade en het schuiven.

   Alles wat hier staat is versiering op iets dat zonder JavaScript al
   werkt. Het zoekveld is een gewoon formulier naar /search met een
   ingevulde placeholder, de eerste hero-foto staat zichtbaar in de HTML,
   en de pillrij is een scrollbare rij die je kunt vegen. Valt dit bestand
   weg, dan blijft de pagina bruikbaar.

   Twee dingen komen overal terug: niets doet iets bij
   prefers-reduced-motion, en de datalayer krijgt drie soorten kliks door.
*/
(function () {
  'use strict';

  var rustig =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function meet(naam, gegevens) {
    window.dataLayer = window.dataLayer || [];
    var lading = { event: naam };
    lading[naam.replace('solza_', '')] = gegevens;
    window.dataLayer.push(lading);
  }

  /* ---------- typmachine in het zoekveld ----------

     De zinnen komen uit een data-attribuut en niet uit dit bestand: welke
     voorbeelden er staan is een redactionele keuze en hoort in de
     theme-editor thuis.

     Bij focus stopt hij definitief. Iemand die begint te typen wil geen
     tekst zien verschijnen en verdwijnen achter zijn eigen woorden; de
     placeholder valt dan terug op de vaste zin. */
  function typmachine() {
    var veld = document.querySelector('[data-solza-home-zoekveld]');
    if (!veld) return;

    var vast = veld.getAttribute('data-vaste-tekst') || '';
    if (rustig) {
      veld.placeholder = vast;
      return;
    }

    var ruw = veld.getAttribute('data-voorbeelden') || '';
    var zinnen = ruw
      .split('|')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
    if (!zinnen.length) {
      veld.placeholder = vast;
      return;
    }

    var zin = 0;
    var pos = 0;
    var modus = 'typen';
    var wacht = 0;
    var cursor = true;
    var tik = 0;
    var klaar = false;

    var timer = window.setInterval(function () {
      if (klaar) return;
      tik++;
      if (tik % 9 === 0) cursor = !cursor;

      var huidig = zinnen[zin];
      if (modus === 'typen') {
        if (pos < huidig.length) {
          /* Om de andere tik een letter erbij: het interval van 55ms
             stuurt ook de cursor, en letter voor letter op die snelheid
             leest als haast. */
          if (tik % 2 === 0) pos++;
        } else {
          modus = 'pauze';
          wacht = 36;
        }
      } else if (modus === 'pauze') {
        if (--wacht <= 0) modus = 'wissen';
      } else {
        if (pos > 0) {
          pos--;
        } else {
          zin = (zin + 1) % zinnen.length;
          modus = 'typen';
        }
      }

      veld.placeholder = huidig.slice(0, pos) + (cursor ? '▏' : ' ');
    }, 55);

    /* Twee aanleidingen om te stoppen, en allebei definitief. Focus is de
       gewone; input is het vangnet voor het geval een browser of een
       plakactie geen focus-event levert. Zonder dat vangnet zou er tekst
       blijven verschijnen en verdwijnen achter de woorden van de bezoeker. */
    function stop() {
      klaar = true;
      window.clearInterval(timer);
      veld.placeholder = vast;
    }

    veld.addEventListener('focus', stop, { once: true });
    veld.addEventListener('input', stop, { once: true });
  }

  /* ---------- hero-foto's met een fade ---------- */
  function fotofade() {
    var bak = document.querySelector('[data-solza-home-fotos]');
    if (!bak) return;
    var fotos = bak.querySelectorAll('img');
    if (fotos.length < 2 || rustig) return;

    var i = 0;
    window.setInterval(function () {
      fotos[i].classList.remove('is-aan');
      i = (i + 1) % fotos.length;
      fotos[i].classList.add('is-aan');
    }, 5000);
  }

  /* ---------- rijen laten schuiven ----------

     De sprong is twee kaarten breed en wordt uit de eerste kaart
     afgeleid, niet uit een vast getal: de kaarten zijn per sectie anders
     breed en een vaste sprong laat er dan een half in beeld staan. */
  function schuiven() {
    document.addEventListener('click', function (e) {
      var knop = e.target.closest && e.target.closest('[data-solza-home-schuif]');
      if (!knop) return;

      var richting = knop.getAttribute('data-solza-home-schuif') === 'terug' ? -1 : 1;
      var doelnaam = knop.getAttribute('data-doel');
      var rij = doelnaam
        ? document.getElementById(doelnaam)
        : knop.parentElement.querySelector('[data-solza-home-rij]');
      if (!rij || !rij.firstElementChild) return;

      var stap = (rij.firstElementChild.offsetWidth + 16) * 2;
      rij.scrollBy({ left: richting * stap, behavior: rustig ? 'auto' : 'smooth' });
    });
  }

  /* ---------- de drie gebeurtenissen ---------- */
  function meten() {
    var zoek = document.querySelector('[data-solza-home-zoekform]');
    if (zoek) {
      zoek.addEventListener('submit', function () {
        var veld = zoek.querySelector('input[name="q"]');
        meet('solza_home_zoeken', { term: veld ? veld.value.trim() : '' });
      });
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      var pil = e.target.closest('[data-solza-home-pil]');
      if (pil) {
        meet('solza_home_pil', {
          label: pil.getAttribute('data-solza-home-pil') || '',
          bestemming: pil.getAttribute('href') || ''
        });
        return;
      }

      var look = e.target.closest('[data-solza-home-look]');
      if (look) {
        meet('solza_home_look', {
          product: look.getAttribute('data-solza-home-look') || '',
          bestemming: look.getAttribute('href') || ''
        });
      }
    });
  }

  /* ---------- tabs ----------

     De knoppen en de panelen horen bij elkaar via een nummer in een
     data-attribuut, niet via hun volgorde in de DOM: een tab waarvan de
     collectie leeg is rendert niet, en dan lopen de indexen uit de pas. */
  function tabs() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var knop = e.target.closest('[data-solza-home-tab]');
      if (!knop) return;

      var balk = knop.closest('[data-solza-home-tabs]');
      var sectie = knop.closest('.solza-home-tabs');
      if (!balk || !sectie) return;

      var nummer = knop.getAttribute('data-solza-home-tab');

      balk.querySelectorAll('[data-solza-home-tab]').forEach(function (k) {
        var aan = k === knop;
        k.classList.toggle('is-aan', aan);
        k.setAttribute('aria-selected', aan ? 'true' : 'false');
      });

      sectie.querySelectorAll('[data-solza-home-paneel]').forEach(function (paneel) {
        paneel.classList.toggle(
          'is-aan',
          paneel.getAttribute('data-solza-home-paneel') === nummer
        );
      });
    });
  }

  /* De bladerpijlen boven de tabs schuiven de rij van het zichtbare
     paneel; welke dat is verandert bij elke tabwissel, dus dat wordt bij
     de klik bepaald en niet vooraf vastgelegd. */
  function tabpijlen() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var knop = e.target.closest('[data-tabs]');
      if (!knop) return;

      var sectie = knop.closest('.solza-home-tabs');
      if (!sectie) return;
      var paneel = sectie.querySelector('.solza-home-tabs__paneel.is-aan');
      var rij = paneel && paneel.querySelector('[data-solza-home-rij]');
      if (!rij || !rij.firstElementChild) return;

      var richting = knop.getAttribute('data-solza-home-schuif') === 'terug' ? -1 : 1;
      var stap = (rij.firstElementChild.offsetWidth + 16) * 2;
      rij.scrollBy({ left: richting * stap, behavior: rustig ? 'auto' : 'smooth' });
    });
  }

  function start() {
    typmachine();
    fotofade();
    schuiven();
    tabs();
    tabpijlen();
    meten();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
